import React from 'react'
import { InputHelperTextProps } from './InputHelperText.types'

export const InputHelperText: React.FC<InputHelperTextProps> = ({
  name,
  error,
  helperText,
}) => {
  const helperStyles = 'w-full flex sh-body-xs pt-1 gap-2'
  const errorStyles = 'pl-4 color-textRisk'
  // helperText allows parents to target the intructional text
  const instructionStyles = 'text-right flex-grow helperText'

  if (!error && !helperText) return null

  return (
    <div className={helperStyles}>
      {!!error && (
        <div
          className={errorStyles}
          id={`${name}-error`}
          data-testid={`info_${name}_error`}
        >
          {error}
        </div>
      )}
      {!!helperText && (
        <div className={instructionStyles} id={`${name}-helper`}>
          {helperText}
        </div>
      )}
    </div>
  )
}
